import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Menu } from "../../../../api";
import { MenuItem } from "../MenuItem";

const menuController = new Menu();

export function ListMenu(props) {
  const { active, reload, onReload } = props;
  const [menus, setMenus] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        setMenus(null); //esto es para que no se quede en el estado anterior
        const response = await menuController.getMenus(active);
        setMenus(response); //esto me devuelve un array de objetos
        // console.log("response......", response);
      } catch (error) {
        throw error;
      }
    })();
  }, [active, reload]);

  if (!menus) return <Loader active inline="centered" />;
  if (size(menus) === 0) return <h2>No hay menus</h2>;

  return map(menus, (subMenus, index) => {
    // Asegúrate de que subMenus es un array y tiene items
    if (!Array.isArray(subMenus) || subMenus.length === 0) {
      // console.error("No sub-menus available or not an array:", subMenus);
      return null;
    }

    return subMenus.map((menu, subIndex) => {
      // Aquí no usas menu[0]._id porque cada 'menu' ya es un objeto individual
      // console.log("Processing menu item:", menu);

      // Verificar si el _id existe antes de usarlo para evitar errores
      if (!menu._id) {
        //  console.error("Invalid menu data", menu);
        return null;
      }

      // Asegúrate de que las claves sean únicas en todo el arreglo de menús
      return (
        <MenuItem
          key={`${index}-${subIndex}-${menu._id}`}
          menu={menu}
          onReload={onReload}
        />
      );
    });
  });
}
